import { LOCATION_CHANGE } from 'connected-react-router';
import { NAVIGATION_DISABLE, NAVIGATION_ENABLE } from '../actions/constants/navigation.constants';

const initialState = {
  enabled: true,
  allowBack: false,
};

export default function navigableReducer(state = initialState, { type }) {
  switch (type) {
    case NAVIGATION_DISABLE: {
      return { ...state, enabled: false };
    }
    case NAVIGATION_ENABLE: {
      return { ...state, enabled: true };
    }
    case LOCATION_CHANGE: {
      const timestamp = new Date();
      return { ...state, location: timestamp.getTime() };
    }
    default:
      return state;
  }
}
